'use client'

import a__default, { memo, useMemo } from "react";
import { Text } from "../Text/Text.js";
import { variants } from "../Text/Text.css.js";
import { classNames } from "../../utils/styles/classNames.js";
import { defaultProps } from "./LoadingSkeleton.defaultProps.js";
import { getCommonProps } from "./utils/getCommonProps.js";
import { wrapper, lastTextRow, textWrapper, textSkeleton } from "./LoadingSkeleton.css.js";
function LoadingSkeletonComponent({
  a11yLabel,
  sectionWidth,
  sectionHeight,
  variant: variantProp,
  onDark,
  textRows,
  textVariant: textVariantProp,
  a11yHidden
}) {
  const width = sectionWidth && sectionWidth > 0 ? sectionWidth : void 0;
  const height = sectionHeight && sectionHeight > 0 ? sectionHeight : defaultProps.sectionHeight;
  const variant = variantProp || defaultProps.variant;
  const textVariant = textVariantProp || defaultProps.textVariant;
  const commonProps = useMemo(
    () => getCommonProps({ onDark, a11yHidden }),
    [variant, onDark, textVariant, a11yHidden]
  );
  const a11yLabelJsx = !a11yHidden && /* @__PURE__ */ a__default.createElement(Text, { visuallyHidden: true }, a11yLabel || defaultProps.a11yLabel);
  if (variant === "text") {
    const { className: skeletonClassName, ...rest } = commonProps;
    const hasMultipleTextRows = textRows && textRows > 1;
    const textsJsx = new Array(textRows).fill(0).map((_, i) => /* @__PURE__ */ a__default.createElement(
      "div",
      {
        className: classNames(
          textWrapper,
          variants[textVariant],
          hasMultipleTextRows && i === textRows - 1 && lastTextRow
        ),
        key: i
      },
      /* @__PURE__ */ a__default.createElement("div", { className: classNames(skeletonClassName, textSkeleton) })
    ));
    return /* @__PURE__ */ a__default.createElement("div", { ...rest, className: wrapper }, a11yLabelJsx, textsJsx);
  }
  return /* @__PURE__ */ a__default.createElement(
    "div",
    {
      ...commonProps,
      style: variant === "section" ? { maxWidth: width, height } : void 0
    },
    a11yLabelJsx
  );
}
const LoadingSkeleton = /* @__PURE__ */ memo(LoadingSkeletonComponent);
export {
  LoadingSkeleton
};
